import React from 'react';
import { Tracker } from '@udemy/event-tracking';
import { useI18n } from '@udemy/i18n';
import { useUDData } from '@udemy/ud-data';
import { CategoryNavItemSelectEvent } from '../../../events';
import { getBrowseURL } from '../../../get-browse-url';
import { MobileNavItem, MobileNavL2Nav, MobileNavSection } from '../mobile-nav.react-component';
export const MobileSubcategoryNav = ({
  parentCategory,
  subcategories
}) => {
  const {
    gettext,
    interpolate
  } = useI18n();
  const udData = useUDData();
  function handleSubcategoryNavClick(item) {
    const context = {
      categoryId: parentCategory.id,
      subcategoryId: item.id,
      topicId: null,
      uiRegion: 'mobile_nav'
    };
    Tracker.publishEvent(new CategoryNavItemSelectEvent({
      context
    }));
  }
  return /*#__PURE__*/React.createElement(MobileNavL2Nav, {
    id: `header-toggle-side-nav-subcategories-of-${parentCategory.id}`,
    l1NavId: "header-toggle-side-nav-categories",
    l1NavTitle: gettext('All Categories')
  }, /*#__PURE__*/React.createElement(MobileNavSection, null, /*#__PURE__*/React.createElement(MobileNavItem, {
    href: getBrowseURL(parentCategory.absolute_url, udData.Config.brand.has_organization)
  }, /*#__PURE__*/React.createElement("span", {
    className: "ud-heading-md"
  }, interpolate(gettext('All %(category)s'), {
    category: parentCategory.title
  }, true))), subcategories === null || subcategories === void 0 ? void 0 : subcategories.map(subcategory => /*#__PURE__*/React.createElement(MobileNavItem, {
    onClick: () => handleSubcategoryNavClick(subcategory),
    key: `l2-mobile-subcategory-id-${subcategory.id}`,
    href: getBrowseURL(subcategory.absolute_url, udData.Config.brand.has_organization),
    "data-purpose": "subcategory-item"
  }, subcategory.title))));
};
//# sourceMappingURL=mobile-subcategory-nav.react-component.js.map